"use client"
import { useState } from "react"
import { useRouter } from "next/navigation"
import { ThumbsUp } from "lucide-react"

interface Props {
  reviewId: string
  initialCount: number
  initialVoted: boolean
  isLoggedIn: boolean
}

export function HelpfulButton({ reviewId, initialCount, initialVoted, isLoggedIn }: Props) {
  const router = useRouter()
  const [count, setCount] = useState(initialCount)
  const [voted, setVoted] = useState(initialVoted)
  const [loading, setLoading] = useState(false)

  async function toggle() {
    if (!isLoggedIn) {
      router.push("/login")
      return
    }
    setLoading(true)
    const res = await fetch(`/api/reviews/${reviewId}/vote`, { method: "POST" })
    setLoading(false)
    if (res.ok) {
      const data = await res.json()
      setVoted(data.voted)
      setCount((c) => c + (data.voted ? 1 : -1))
    }
  }

  return (
    <button
      onClick={toggle}
      disabled={loading}
      className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border transition-colors ${
        voted
          ? "border-[var(--primary)] text-[var(--primary)] bg-[var(--primary)]/5"
          : "border-[var(--border)] text-[var(--muted-foreground)] hover:border-[var(--foreground)] hover:text-[var(--foreground)]"
      } disabled:opacity-50`}
      aria-label={voted ? "Remove helpful vote" : "Mark as helpful"}
    >
      <ThumbsUp
        size={12}
        className={voted ? "fill-[var(--primary)]" : ""}
      />
      {count > 0 ? `${count} helpful` : "Helpful"}
    </button>
  )
}
